import {Injector} from '@angular/core';

export class ServiceInjector {
  static injector: Injector;
}
